import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import type { TSummaryType } from 'shared/types/TRankingService';

const SUMMARY_VARIANTS: Record<MPLPreApprovalOffer['productType'], TSummaryType[]> = {
  credit: ['LoanAmount', 'LoanPerMonth'],
  credit_card: ['LoanAmount', 'LoanGracePeriod'],
  microcredit: ['LoanAmount', 'LoanTerm'],
};

export const getSummaryTypesOrderByProductType = (productType: MPLPreApprovalOffer['productType']): TSummaryType[] => {
  return SUMMARY_VARIANTS[productType] || SUMMARY_VARIANTS.credit;
};
